


































import Enumerable from "linq";
import { Component, Mixins, Watch, Emit, Prop } from "vue-property-decorator";
import { MultiSelectableMixin } from "./mixins";
import { BrowserUtility, BrowserKinds } from "../../../utilities";
import InfiniteLoading from "vue-infinite-loading";

@Component({
  components: {
    InfiniteLoading
  },
})
export default class MultiListBoxSelector extends Mixins(MultiSelectableMixin) {
  // TODO Firefox対応時にホイールでスクロール量減少問題があったためselectタグを使用しない実装を検討する
  @Prop({default: 50 })
  loadChunkSize: number;

  data(): any {
    return {
      chunkedCount: 0,
      loadedOptions: [],
      infiniteLoading: null,
    };
  }
  infiniteLoading: InfiniteLoading;
  chunkedCount: number;
  loadedOptions: any[];

  created() {
    this.$logger.debug("MultiListBoxSelector created.");
  }

  mounted(): void {
    this.$logger.debug("MultiListBoxSelector mounted.");
    this.infiniteLoading = this.$refs.infiniteLoading as InfiniteLoading;
    this.filteredOptionsUpdated(this.filteredOptions);
  }

  beforeUpdate() {
    this.$logger.debug("MultiListBoxSelector beforeUpdate.");
  }

  updated() {
    this.$logger.debug("MultiListBoxSelector updated.");
  }

  onInfinite(): void {
    this.$logger.debug("onInifinite");
    this.chunkList();
  }

  private chunkList(): void {
    for (let i = this.chunkedCount; i < (this.chunkedCount + this.loadChunkSize); i++) {
      if (i >= this.filteredOptions.length) {
        this.$logger.debug("call complete. i is " + i);
        this.infiniteLoading.stateChanger.complete();
        return;
      }

      this.loadedOptions.push(this.filteredOptions[i]);
    }
    this.chunkedCount += this.loadChunkSize;

    this.$logger.debug("call loaded. chunkedCount is " + this.chunkedCount);
    this.infiniteLoading.stateChanger.loaded();
  }

  wheelSelect(e: WheelEvent): void {
    // Firefoxでスクロール量が少なくなるための対策
    // selectタグのイベントで発生したスクロール量が親のdivのスクロールに影響している模様
    // スクロール量は行単位(DeltaMode=1)でdeltaY=2.5を指していたが、ピクセル単位でスクロールしているように見える。
    // selectタグでスクロールイベントを親に通知しないことで対策した。
    // ブラウザチェックをしているのはIEでは動作しなくなるため。
    if (BrowserUtility.getBrowserKind() === BrowserKinds.MozillaFirefox) {
      e.stopPropagation();
    }
  }

  wheel(e: WheelEvent): void {
    // IEでselectタグにフォーカスがある場合スクロールが行われないので手動で制御
    e.preventDefault();
    if (e.currentTarget instanceof HTMLDivElement) {
      e.currentTarget.scrollLeft += e.deltaX;
      e.currentTarget.scrollTop += e.deltaY;
    }
  }

  @Watch("filteredOptions")
  onFilteredOptionsUpdated(newValue: any[], oldValue: any[]): void {
    this.resetChunkList();

    // 選択状態を更新
    this.selectedOptions = Enumerable.from(this.selectedOptions)
      .where(o => this.optionFilter(o))
      .toArray();
    
    this.filteredOptionsUpdated(newValue);
  }

  @Watch("loadedOptions")
  onLoadedOptionsUpdated() {
    this.loadedOptionsUpdated(this.loadedOptions);
  }

  // ローディング状態をリセット
  resetChunkList(): void {
    this.loadedOptions = [];
    this.chunkedCount = 0;

    if (this.infiniteLoading) {
      this.$logger.debug("call reset.");
      this.infiniteLoading.stateChanger.reset();
    }
  }

  @Emit()
  keyup(e: KeyboardEvent): void {}

  @Emit()
  keydown(e: KeyboardEvent): void {}

  @Emit()
  loadedOptionsUpdated(loadedOptions: any[]): void {}

  @Emit()
  filteredOptionsUpdated(filteredOptions: any[]): void {}

  dblclick(e: PointerEvent): void {
    // フィルタで0件になってもselectタグは2行分の領域があるためイベントが発生してしまう
    // また、その際フィルタ以前に選択した状態が維持されるため、そのまま選択されてしまう
    // そのためフィルタが更新された際、範囲外の場合選択状態を解除し、ダブルクリックでは未選択は通知を行わない
    if (this.selectedOptions === null || this.selectedOptions.length === 0) {
      return;
    }
    this.$emit("dblclick", e);
  }
}
